export default "__VITE_ASSET__tY5Olamt__"